import { render, staticRenderFns } from "./user-paymentconfirmation.vue?vue&type=template&id=0ee5f5e1&scoped=true"
import script from "./user-paymentconfirmation.vue?vue&type=script&lang=js"
export * from "./user-paymentconfirmation.vue?vue&type=script&lang=js"
import style0 from "./user-paymentconfirmation.vue?vue&type=style&index=0&id=0ee5f5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5f5e1",
  null
  
)

export default component.exports